import { useEffect, useState } from 'react';

import { TOUR_PAST_SEARCH } from '@constants/constants';
import { TourTypes } from '@domain/tour/tourAutoComplate';

/**
 * Custom hook to manage past searches from the tour
 */
export const useTourPastSearches = () => {
  const [pastTourItems, setPastTourItems] = useState<TourTypes[]>([]);

  useEffect(() => {
    const pastItems =
      typeof window !== 'undefined' && localStorage.getItem(TOUR_PAST_SEARCH)
        ? JSON.parse(localStorage.getItem(TOUR_PAST_SEARCH) || '')
        : [];

    setPastTourItems(pastItems);
  }, []);

  /**
   * Handle save items to local storage
   */
  const saveTourSearch = (newTourItem: TourTypes) => {
    if (typeof window !== 'undefined') {
      if (pastTourItems.find((p) => p?.id === newTourItem?.id)) return;
      localStorage.setItem(
        TOUR_PAST_SEARCH,
        JSON.stringify([...pastTourItems, newTourItem])
      );
      setPastTourItems((prev) => [...prev, newTourItem]);
    }
  };

  /**
   * Clear past search history items
   */
  const clearPastTourSearch = () => {
    if (typeof window !== 'undefined') {
      localStorage.removeItem(TOUR_PAST_SEARCH);
      setPastTourItems([]);
    }
  };

  /**
   * Remove one item from local storage
   */
  const removePastTourSearch = (item: TourTypes) => {
    const newItems = pastTourItems?.filter(
      (i: TourTypes) => i?.text !== item?.text
    );

    setPastTourItems(newItems);

    if (typeof window !== 'undefined')
      localStorage.setItem(TOUR_PAST_SEARCH, JSON.stringify(newItems));
  };

  return {
    pastTourItems,
    saveTourSearch,
    clearPastTourSearch,
    removePastTourSearch,
  };
};
